


























import Card from '@/components/UI/Card.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue';
import '@/extensions';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import {ISaleSaveDto, ISale, ISaleQueryDto, ISaleResponseDto, ISaleTableItem} from "@/pages/Sales/data";
import SalesApi from "@/pages/Sales/SalesApi";
import mermaid from 'mermaid';

@Component({
    components: {
        vSelect,
        CollapseCard,
        Card,
    },
})

export default class SalesListGanttDiagram extends Mixins(LocalData, Http) {
    @Prop({required: true}) readonly api!: SalesApi;

    mounted() {
        this.isDiagramLoading = true;

        mermaid.initialize({
            startOnLoad: true,
            securityLevel: 'loose'
        });

        mermaid.ganttConfig = {
            // titleTopMargin: 0, // Margin top for the text over the diagram
            // barHeight: 25, // The height of the bars in the graph
            // barGap: 6, // The margin between the different activities in the gantt diagram
            // topPadding: 20, // Margin between title and gantt diagram and between axis and gantt diagram.
            // bottomPadding: 40, // Margin between title and gantt diagram and between axis and gantt diagram.
            // rightPadding: 20, // The space allocated for the section name to the right of the activities
            // leftPadding: 20, // The space allocated for the section name to the left of the activities
            // gridLineStartPadding: 16, // Vertical starting position of the grid lines
            // fontSize: 13, // Font size
            // sectionFontSize: 10, // Font size for sections
            // numberSectionStyles: 1, // The number of alternating section styles
            // axisFormat: '%d/%m', // Date/time format of the axis
            tickInterval: '1day', // Axis ticks
            topAxis: true, // When this flag is set, date labels will be added to the top of the chart
            // displayMode: "", // Turns compact mode on
            // weekday: 'sunday', // On which day a week-based interval should start
        };

        this.$nextTick(() => {
            this.fetchSales();
        });
    }

      @Watch('itemsForDiagram', {deep: true})
      regenerateDiagram() {
          this.generateGanttDiagram();
      }

      @Watch('ganttDiagram')
      renderMermaid() {
        this.$nextTick(() => {
            this.diagramKey++;

            this.$nextTick(() => {
                mermaid.contentLoaded();

                this.addClickListeners();
            });
        })
      }

    private ganttDiagram: string = '';
    private diagramKey: number = 1;
    private isDiagramLoading: boolean = true;
    private isSaleLoading: boolean = false;
    private itemsForDiagram: Array<ISaleResponseDto> = [];
    private ganttContainerWidth: string = '100%';
    private ganttContainerHeight: string = '30vh';

    private getDaysCount(ranges: Array<ISaleResponseDto>): number {
        const { minDate, maxDate } = ranges.reduce<{
            minDate: Date | null;
            maxDate: Date | null;
        }>((acc, { startDate, endDate }) => {
            const start = new Date(startDate as string);
            const end = new Date(endDate as string);

            if (!acc.minDate || start < acc.minDate) {
                acc.minDate = start;
            }

            if (!acc.maxDate || end > acc.maxDate) {
                acc.maxDate = end;
            }

            return acc;
        }, { minDate: null, maxDate: null });

        if (!minDate || !maxDate) {
            return 0;
        }

        const timeDiff = maxDate.getTime() - minDate.getTime(); // in milliseconds
        return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    }

    private generateGanttDiagram() {
        const tasks = this.itemsForDiagram.map(item => {
            return `${(this.getSaleTypeLabel(item.type) + '#46; ' + item.name).trim()} :${item.id}, ${item.startDate}, ${item.endDate}`;
        }).join('\n');

        const daysCount = this.getDaysCount(this.itemsForDiagram);

        this.ganttContainerWidth = daysCount > 80 ? daysCount * 20 + 'px' : '100%';
        this.ganttContainerHeight = this.itemsForDiagram.length * 25 + 100 + 'px';

        this.ganttDiagram = `gantt\ndateFormat  YYYY-MM-DD\n${tasks}`;
    }

    addClickListeners() {
        this.$nextTick(() => {
            const tasks = document.querySelectorAll('.task');
            const taskTexts = document.querySelectorAll('.taskText');

            tasks.forEach(task => {
                task.addEventListener('click', (event) => {
                    if (event.currentTarget) {
                        const saleId = (event.currentTarget as HTMLElement).getAttribute('id');
                        this.handleSaleClick(saleId as string);
                    }
                });
            });

            taskTexts.forEach(taskText => {
                taskText.addEventListener('click', (event) => {
                    if (event.currentTarget) {
                        const saleId = (event.currentTarget as HTMLElement).getAttribute('id');
                        this.handleSaleClick((saleId as string).replace('-text', ''));
                    }
                });
            });
        });
    }

    handleSaleClick(saleId: string) {
        // TODO here will request to server for fetch single Sale as for table by id - after adding route on Backend
        // next - temporary, emulation
        this.isSaleLoading = true;

        setTimeout(() => {
            const sale = this.itemsForDiagram.find(saleObj => saleObj.id === Number(saleId));

            this.isSaleLoading = false;

            this.$emit('open-params-tab', sale);
        }, 500)
    }

     fetchSales() {
        if (!this.$sales.selectMarket.id) {
            return;
        }

        this.isDiagramLoading = true;

        const usualParams = {
          page: 0,
          size: 1000,
          tradingId: this.$sales.selectMarket.id,
        };

        this.api.fetchSales(usualParams)
            .then((resp) => {
                if (resp.status === 200) {
                    const array: ISaleTableItem[] = [];

                    resp.data.content.forEach((e: ISaleResponseDto) => {
                        array.push({
                            id: e.id,
                            tradingId: e.tradingId,
                            groups: e.groups,
                            categories: e.categories,
                            subcategory: e.subcategory,
                            clusters: e.clusters,
                            format: e.format,
                            regions: e.regions,
                            status: e.status,
                            type: e.type,
                            skuCount: e.skuCount,
                            remains: e.remains,
                            taskId: e.taskId,
                            startDate: e.startDate,
                            endDate: e.endDate,
                            name: e.name,
                            stagesNumber: e.stagesNumber,
                            minSaleDiscount: e.minSaleDiscount,
                            maxSaleDiscount: e.maxSaleDiscount,
                            minMargin: e.minMargin,
                            considerPlannedSeason: false, // временно, после доработок по бэку убрать and uncomment below
                            revaluationFileName: e.revaluationFileName, // временно, после доработок по бэку убрать and uncomment below
                            // considerPlannedSeason: e.considerPlannedSeason,
                        })
                    })

                    this.itemsForDiagram = Object.assign([], array);

                    this.isDiagramLoading = false;
                }
            })
            .catch((e) => {
                this.showError(this.$t('salesListTab.messages.errorLoadSales') as string)
                console.error(e);
            })
    }

    getSaleTypeLabel(typeValue: string | null = null) {
        const typeObj = this.saleTypeOptions.find(option => option.value === typeValue);

        return typeObj ? typeObj.label : this.$t('shared.messages.unknownType') as string;
    }
}

